import React, { FC } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress, { CircularProgressProps } from "@mui/material/CircularProgress";
import "./LoadingSpinner.scss";
import { Box, Typography } from "@mui/material";

interface LoadingSpinnerProps {
  open: boolean;
  determinate?: boolean
}

const CircularProgressWithLabel = (
  props: CircularProgressProps & { value: number },
) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}


const LoadingSpinner: FC<LoadingSpinnerProps> = ({ open, determinate }) => {
  const [progress, setProgress] = React.useState(0)

  React.useEffect(() => {
    if(open){
      setProgress(0)
    }
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress+ 5 >= 99 ? 99 : prevProgress + 5));
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, [open]);
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 500 }}
      open={open}
    >
      {determinate && determinate? <CircularProgressWithLabel color="inherit" value={progress}/>
:      <CircularProgress color="inherit" />}
      
    </Backdrop>
  );
};

export default LoadingSpinner;
